import styled from 'styled-components'
import { flex, FlexProps, layout, LayoutProps, space, SpaceProps } from 'styled-system'

export const InputIconsContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: center;
`

export const RequiredAsteriskStyled = styled.p`
	position: relative;
	top: 4px;
	display: block;
	color: var(--error);
`

export const TextInputContainerStyled = styled.div<LayoutProps>`
	${layout};
	display: flex;
	justify-content: space-between;
	align-items: center;
	/* margin: 16px 0; */
	border-bottom: 1px solid var(--border);
	transition: border-color var(--dur-fast) var(--ease);
	&:focus-within {
		border-bottom-color: var(--blue);
	}
`

export const TextInputStyled = styled.input<SpaceProps>`
	${space};
	width: 100%;
	border: none;
	padding: 20px 0;
	padding: 10px 0;
	background-color: transparent;
	font-size: 16px;

	// hide number arrows for chrome
	::-webkit-inner-spin-button,
	::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	// hide number arrows for mozilla
	-moz-appearance: textfield;

	::placeholder {
		color: var(--text-secondary);
		opacity: 1;
	}

	:-ms-input-placeholder {
		/* Internet Explorer 10-11 */
		color: var(--text-secondary);
	}

	::-ms-input-placeholder {
		/* Microsoft Edge */
		color: var(--text-secondary);
	}

	:focus {
		outline: none;
	}
	/* ::-webkit-calendar-picker-indicator {
		display: none;
	} */
`
export const TextInputWrapper = styled.div<FlexProps>`
	flex-grow: 1;
	position: relative;
	${flex}
`
export const TextInputLabel = styled.label<{ placeholder?: string }>`
	font-size: 12px;
	font-family: var(--font-sans);
	color: var(--text-secondary);
	visibility: ${props => (props.placeholder ? 'visible' : 'hidden')};
`
